<i18n>
{
	"en": {
		"title": "Owner",
		"mandatoryField": "Owner is a mandatory field",
		"missingNameAndVendorNumber": "Must contain name and vendor number",
		"missingName": "Must have a name",
		"missingPostalCode": "Must have a vendor number"
	},
	"no": {
		"title": "Eier",
		"mandatoryField": "Eier er påkrevd",
		"missingNameAndVendorNumber": "Må inneholde navn og leverandørnummer",
		"missingName": "Må ha et navn",
		"missingVendorNumber": "Må ha et leverandørnummer"
	}
}
</i18n>
<template>
	<div>
		<t-combobox-button
			ref="comboboxButton"
			:title="label || $t('title')"
			icon="geosearch"
			:limit="$options.SERVER_RETURN_LIMIT"

			:searchValue="searchValue"
			:items="filteredItems"
			:selected="value"

			:disabled="disabled"
			disableButtonTabbing

			@focus="onFocus"
			@input="onInput"
			@change="onChange"
			@blur="onBlur"
			@button:click="setShowDialog(true)"
		>
			<template #optionItemContent="slotProps">
				<div class="item">
					<div class="item-main-text">{{ slotProps.item.name }}</div>
					<div class="item-sub-text">{{ slotProps.item.vendorNumber }}</div>
				</div>
			</template>

		</t-combobox-button>

		<t-after-input :text="vendorNumber" />

		<vendors-form-input-dialog
			:items="vendors"
			:isShown="showDialog"
			:initialSearchValue="searchValue"
			icon="unknown-vehicle"
			@close="setShowDialog(false)"
			@ok="onChange"
		/>
	</div>
</template>

<script>
import { mapState, mapActions } from './store/vendors.store.js';
import formMixin from '@/components/evergreen/inputs/formMixin';
import popoverMixin from '@/components/evergreen/inputs/popoverMixin';
import VendorsFormInputDialog from './VendorsFormInput/VendorsDialog';
import TAfterInput from '@/components/evergreen/timpex/inputs/TAfterInput';
import TComboboxButton from '@/components/evergreen/timpex/inputs/TComboboxButton';

export default {
	name: 'VendorInput',
	components: { TComboboxButton, TAfterInput, VendorsFormInputDialog },
	mixins: [ formMixin, popoverMixin ],
	props: {
		value: Object,
		eagerLoad: Boolean,
		validationKey: [String, Boolean],
		disabled: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			showDialog: false,
			searchValue: '',
			loaded: false,
			focused: false,
		};
	},
	computed: {
		...mapState(['vendors']),
		vendorNumber() {
			if (this.value && this.value.vendorNumber) {
				return `${this.value.vendorNumber}`;
			} else return '';
		},

		filteredItems() {
			return this.vendors.filter( item => {

				if (!item)
					return false;

				let loweredSearchValue = this.searchValue.toLowerCase();

				let ret = true;
				for (let c of loweredSearchValue.split(' ')) {
					ret = ret &&
						( (item.name && item.name.toLowerCase().includes(c))
							|| ( item.vendorNumber && item.vendorNumber.toString().toLowerCase().includes(c) )
						);
				}
				return ret;
			});
		}
	 },
	watch: {
		value: {
			immediate: true,

			handler(value) {
				this.searchValue = this.getSearchValueFromValue(value);
			}
		}
	},
	async created() {
		if (this.eagerLoad) this.loadVendorsIfNotLoaded();
	},

	methods: {
		...mapActions(['getVendors']),
		onFocus() {
			this.focused = true;
			this.loadVendorsIfNotLoaded();
		},
		onInput(searchValue) {
			this.searchValue = searchValue;
		},
		onChange(event) {
			this.searchValue = this.getSearchValueFromValue(event);

			this.$emit('change', event);
		},
		onBlur(event) {

			this.focused = false;

			if (!isRelatedTargetButton(event, this.$refs.comboboxButton)) {

				if (this.searchValue === '')
					this.$emit('change', {});

				else
					this.searchValue = this.getSearchValueFromValue(this.value);
			}

			function isRelatedTargetButton(event, comboboxButtonRef) {

				return event.relatedTarget
					=== comboboxButtonRef.$refs.textInputButton.$refs.iconButton.$el;
			}
		},
		async loadVendorsIfNotLoaded() {
			if (this.loaded) return;
			try {
				await this.getVendors();
				this.loaded = true;
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('failedToFetch')
				});
			}
		},
		getSearchValueFromValue(value) {

			if (value && value.name && value.name.length)
				return value.name;
			else
				return '';
		},
		setShowDialog(showDialog) {

			if (this.showDialog === true && showDialog === false)
				this.searchValue = this.getSearchValueFromValue(this.value);

			this.showDialog = showDialog;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';

.item {
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
}

.item-main-text {
	height:16px;
	line-height: 16px;
	font-weight: 600;
	overflow: hidden;
	white-space: nowrap;
}

.item-sub-text {
	height:16px;
	font-size: 10px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.6;
	letter-spacing: normal;
	overflow: hidden;
	white-space: nowrap;
}
</style>
